// Copyright (c) 2020 Deere & Company

import actions from '../actions-list';

export const createSuccessMessage = message => ( {
    messages: [
        {
            type: 'Success',
            reference: '',
            message
        }
    ],
    type: actions.ADD_SUCCESS_ALERT_MESSAGE
} );

export const createErrorMessage = message => ( {
    messages: [
        {
            type: 'Error',
            reference: '',
            message
        }
    ],
    type: actions.ADD_ERROR_ALERT_MESSAGE
} );

export const discardMessages = () => ( {
    messageType: 'discard',
    type: actions.DISCARD_ALERT_MESSAGES
} );
